export const accountSettingsModalCloseButtonStyles = {
  position: 'absolute',
  top: '32px',
  right: '32px',
  fontSize: '34px',
  color: 'black',
  cursor: 'pointer',
};

export const accountSettingsModalAvatarStyles = {
  width: '100px',
  height: '100px',
  mr: '50px',
};

export const accountSettingsModalUploadAvatarStyles = {
  width: '150px',
  height: '150px',
  mr: '26px',
};

export const accountSettingsModalTabStyles = {
  justifyContent: 'flex-start',
  w: '100%',
  h: '50px',
  fontSize: '20px',
  fontWeight: 400,
  color: 'black',
  px: '15px',
  py: 0,
  borderRadius: 0,
  borderBottom: '1px solid #DCDCDC',
  _first: {
    borderTopLeftRadius: '20px',
    borderTopRightRadius: '20px',
  },
  _last: {
    borderBottomLeftRadius: '20px',
    borderBottomRightRadius: '20px',
    borderBottom: 'none',
  },
  _selected: {
    bg: 'transparent',
    fontWeight: 500,
    color: 'alea.500',
  },
};

export const accountSettingsModalUploadStyles = {
  alignItems: 'center',
  mb: '29px',
};

export const accountSettingsModalButtonStyles = {
  variant: 'outline',
  borderRadius: '20px',
  fontWeight: 400,
  fontSize: 18,
  h: '50px',
  px: '15px',
};

export const accountSettingsModalDeleteButtonStyles = {
  ...accountSettingsModalButtonStyles,
  color: '#EF5C36',
};

export const accountSettingsModalSubmitButtonStyles = {
  colorScheme: 'alea',
  w: '100px',
  h: '50px',
  borderRadius: '20px',
};
